import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-140" data-mp="bookx19fxr2w">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-141" data-mp="196gawv4bwhoi">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 font-display text-base font-black uppercase text-white shadow-[0_6px_0_0_#0e6b31,0_14px_30px_-6px_rgba(0,0,0,0.45)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:text-lg" data-id="element-142" data-mp="2f4k870i007r0">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-143" data-mp="1wdj8ga92086e" />
            Get Instant Access — Only $27
          </a>
        </motion.div>}
    </AnimatePresence>;
}